/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { View, StyleSheet, Dimensions } from 'react-native';

import { buttonFloating } from '@/assets/styles/buttonStyles';
import * as Layout from '@components/screen/Layout';
import Button from '@components/form/Button';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import { isWeb, isNative } from '@global/screens';
import ItemDetail from '@components/global/ItemDetail';
import StatusBadge from '@components/global/StatusBadge';

import useApi from '@/hooks/useApi';
import { MsAccount } from '@api/ms-account';

const dimension = Dimensions.get('window');

const CustomerTypeDetailScreen = (props) => {
  const userRole = useSelector((state) => state.auth.user.role);
  const hasEditAccess = [
    'superadmin',
    'sales_admin',
    'marketing_admin',
    'general',
  ].includes(userRole && userRole.code);
  const [detailData, setDetailData] = useState({});
  const getCustomerTypeDetail = useApi(MsAccount.getCustomerTypeDetail);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setDetailData({});
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  const getDetail = async (id) => {
    const response = await getCustomerTypeDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      setDetailData(response.data.data);
    }
  };

  return (
    <Layout.Container>
      {isWeb && (
        <Layout.Back
          title="Customer Type"
          onCallback={() =>
            props.navigation.reset({
              index: 0,
              routes: [{ name: 'CustomerTypeScreen' }],
            })
          }
        />
      )}
      <Layout.Wrapper rounded>
        {getCustomerTypeDetail.loading ? (
          <Layout.Loader />
        ) : detailData && Object.keys(detailData).length ? (
          <>
            <Layout.ScrollViewRefresher
              onCallback={() => getDetail(props?.route?.params?.id)}>
              <View style={styles.sectionWrapper}>
                {isWeb && hasEditAccess ? (
                  <View
                    style={[
                      styles.rowContainer,
                      {
                        position: 'relative',
                        zIndex: 1,
                        justifyContent: 'space-between',
                      },
                    ]}>
                    <SociollaText type="medium" style={{ fontSize: 20 }}>
                      Customer Type
                    </SociollaText>
                    <View style={{ position: 'relative' }}>
                      <Button
                        type="primary"
                        rounded
                        buttonStyle={{ width: 80, marginRight: 10 }}
                        title={
                          <SociollaText
                            type="bold"
                            style={{ color: Colors.white }}>
                            Edit
                          </SociollaText>
                        }
                        onPress={() =>
                          props.navigation.navigate('CustomerTypeFormScreen', {
                            id: detailData._id,
                            name: detailData.name ? detailData.name : '-',
                            titleScreen: detailData.name
                              ? detailData.name
                              : '-',
                          })
                        }
                      />
                    </View>
                  </View>
                ) : (
                  false
                )}
                <View
                  style={[
                    { maxWidth: isWeb ? 400 : '100%' },
                    isWeb ? { paddingVertical: 15 } : { paddingBottom: 20 },
                  ]}>
                  <ItemDetail
                    name="Customer Type Name"
                    value={detailData.name ? detailData.name : '-'}
                  />
                  <ItemDetail
                    name="Description"
                    centered
                    value={
                      detailData.description ? detailData.description : '-'
                    }
                  />
                  <ItemDetail
                    name="Status"
                    centered
                    value={
                      <StatusBadge
                        status={detailData.is_active ? 'active' : 'in_active'}
                      />
                    }
                  />
                </View>
              </View>
            </Layout.ScrollViewRefresher>
            {!isWeb && hasEditAccess ? (
              <View style={buttonFloating}>
                <Button
                  type="default"
                  rounded
                  title={
                    <SociollaText
                      type="bold"
                      style={{ fontSize: 16, letterSpacing: 0.5 }}>
                      Edit
                    </SociollaText>
                  }
                  onPress={() =>
                    props.navigation.navigate('CustomerTypeFormScreen', {
                      id: detailData._id,
                      name: detailData.name ? detailData.name : '-',
                      titleScreen: detailData.name ? detailData.name : '-',
                    })
                  }
                />
              </View>
            ) : (
              false
            )}
          </>
        ) : (
          <View style={{ width: '100%', padding: 20 }}>
            <SociollaText>No data found.</SociollaText>
          </View>
        )}
      </Layout.Wrapper>
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  sectionWrapper: { width: '100%', padding: 15 },
  rowContainer: { flexDirection: 'row', alignItems: 'center' },
  detailItem: {
    width: !isNative ? 'calc(100% - 130px)' : dimension.width - 160,
  },
});

export default CustomerTypeDetailScreen;
